export class WorkStationsListDto {
    workStationsData: string[];
}